import React, { useEffect, useState, useMemo } from "react";
import ellipse from "../../assets/images/red-required-Asterisk.svg";
import group from "../../assets/images/earning-invoice-group.svg";
import {
  UploadOutlined,
  FileTextOutlined,
  PlusCircleOutlined,
  DeleteFilled,
  UpOutlined,
  DownOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import "./add-new-invoice-upload-model.scss";
import SuccessCheckIcon from "../../assets/images/check-success-green-icon.svg";
import {
  Row,
  Radio,
  Col,
  Card,
  Tag,
  Button,
  Table,
  Input,
  Divider,
  Space,
  Dropdown,
  Spin,
  Modal,
  Form,
  Select,
  DatePicker,
  Typography,
  Tabs,
  Popover,
  message,
  Tooltip,
  Drawer,
  Pagination,
  Collapse,
  Badge,
} from "antd";
import leftArrow from "../../assets/images/earning-invoice-left-arrow.svg";
import { useTranslation } from "react-i18next";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import InvoiceSummaryCard from "./components/invoice-order-summary-card";
import {
  getInvoiceOrderListFilterMasterData,
  getOrderListForInvoiceGeneration_V2,
  getOrderListInvoiceCreation,
  getTripMoveTypeForInvoicing,
  getVendorInvoiceDraftDetail,
  saveVendorInvoice,
  saveVendorInvoiceDraft,
} from "../../service/earning-invoice/earning-invoice";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import OCRFileUpload from "../../common/ocr-file-upload/ocr-file-upload";
import Fileupload from "../../common/fileupload/fileupload";
import {
  DocTypes,
  EntityTypes,
  INVOICE_STATUS_TYPES,
  ThumbnailImagePath,
} from "../../constants/commonConstants";
import { useStore } from "../../store/store";
import DocumentListView from "../login/sign-up/components/document-list-view";
import {
  checkIsTurkeyKazak,
  getCurrencyCode,
} from "../../util/constantUtility";
import DecimalFormatter from "../../common/decimal-converter/decimal-converter";
import InvoiceInstructions from "./components/invoice-instructions";
import warningIcon from "../../assets/images/warning-alert.png";
import { ocrInvoiceFileUpload } from "../../service/documentService";
import fileSearchGif from "../../assets/images/file-search.gif";
import filterMoreFilter from "../../assets/images/filter-vertical.svg";
import FilterImg from "../../assets/images/filter-vertical-img.svg";
import { MultiSelectFilterSearch } from "../loads/component/multi-select-filter-search/multi-select-filter-search";
import { use } from "i18next";
import moment from "moment";
import * as localStorageService from "../../service/localStorageService";
import { BrandColors } from "../../constants/brand";

const { Text } = Typography;
const { Panel } = Collapse;
dayjs.extend(utc);

const InvoiceUploadModel = () => {
  const navigate = useNavigate();
  const { user } = useStore();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    currency: getCurrencyCode(user?.operatingCountry) || "AED",
    invoiceId: "",
    amount: 0,
    vatAmount: 0,
    totalAmount: 0,
    uploadedInvoice: [],
  });
  console.log("formData", formData);
  const [formFilterState, setFormFilterState] = useState({
    activeFilter: "allTime",
    fromDate: dayjs("2024-01-01").startOf("month").utc(true).toISOString(),
    toDate: dayjs().endOf("month").utc(true).toISOString(),
  });

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [draftOrders, setDraftOrders] = useState([]);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const draftId = searchParams.get("draftId");
  const isDraft = searchParams.get("isDraft") === "true";
  const paramMoveType = searchParams.get("moveType");
  const initialFlow =
    location.state?.flowType || searchParams.get("flow") || "selection";
  const [flowType, setFlowType] = useState(initialFlow);
  const [orderList, setOrderList] = useState([]);
  console.log("orderList",orderList)
  const [savingDraft, setSavingDraft] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [existingDraftID, setExistingDraftID] = useState(null);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [ocrConfirmedFiles, setOcrConfirmedFiles] = useState([]);
  const [uploadedDocs, setUploadedDocs] = useState([]);
  const moveTypesList = [
    { label: t("INV_UPL_SUMMARY_DOMESTIC_LB"), value: "Domestic" },
    { label: t("INV_UPL_SUMMARY_CROSS_BORDER_LB"), value: "Cross Border" },
  ];

  //const [moveType, setMoveType] = useState((isDraft && paramMoveType) ? paramMoveType: "Domestic");
  const [moveType, setMoveType] = useState("");
  // States to view Uploaded documents
  const [documentDrawerOpen, setDocumentDrawerOpen] = useState(false);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(1000);
  const [totalRecord, setTotalRecord] = useState(0);

  // AUTO SELECT NEW CHANGES
  const [removedOrderNumbers, setRemovedOrderNumbers] = useState([]);
  const [moveTypeModalOpen, setMoveTypeModalOpen] = useState(false);
  const [tempMoveType, setTempMoveType] = useState("");
  const [ocrParsedData, setOcrParsedData] = useState(null);
  const [ocrLogId, setOcrLogId] = useState("");
  const [isUploadingPopupVisible, setIsUploadingPopupVisible] = useState(false);
  const initialUploadState = {
    progress: 0,
    status: t("OCR_MODAL_HOLD_TIGHT_MSG"),
    description: t("OCR_MODAL_DO_NOT_CLOSE_MSG"),
    started: false,
  };
  const [uploadState, setUploadState] = useState(initialUploadState);
  const [moveTypeLoader, setMoveTypeLoader] = useState(false);
  const [
    isAdditionalFilterMasterDataLoader,
    setIsAdditionalFilterMasterDataLoader,
  ] = useState(true);
  const [invoiceStatusWiseList, setInvoiceStatusWiseList] = useState([]);
  console.log("invoiceStatusWiseList",invoiceStatusWiseList)
  const [additionalFilterMasterData, setAdditionalFilterMasterData] = useState({
    sourceCities: [],
    destinationCities: [],
    truckTypes: [],
    truckNumbers: [],
    orderIds: [],
    driverIds: [],
  });
  const [ordersFilter, setordersFilter] = useState({
    sourceCities: [],
    destinationCities: [],
    truckTypes: [],
    truckNumbers: [],
    orderIds: [],
    driverIds: [],
  });
  const [selectedInvoiceStatus, setSelectedInvoiceStatus] = useState("");
  const [filterModal, setFilterModal] = useState(false);
  const [appliedFilterCount, setAppliedFilterCount] = useState(0);
  const [applyFilter, setApplyFilter] = useState(false);
  const [finalSelectedOrders, setFinalSelectedOrders] = useState([]);
  const fetchOrders = async () => {
    // AUTO SELECT NEW CHANGES
    try {
      setLoadingOrders(true);
      const payload = {
        fromMoveDate: formFilterState.fromDate,
        toMoveDate: formFilterState.toDate,
        moveType: moveType,
        pageNumber: currentPage,
        pageSize: pageSize,
      };

      const res = await getOrderListInvoiceCreation(payload);
      const orders = res?.data?.data || [];
      setOrderList(orders);
      setTotalRecord(res?.data?.pagination?.totalRecords || 0);
      if (orders?.length === 0 && isDraft) {
        const draftOrderNumbers = new Set(
          draftOrders.map((o) => o.orderNumber),
        );
        const newSelectedCount = selectedOrders.filter((o) =>
          draftOrderNumbers.has(o.orderNumber),
        );
        setSelectedOrders(newSelectedCount);
      } else if (orders?.length === 0) {
        setSelectedOrders([]);
      } else {
        // auto select eligible orders
        setSelectedOrders((prev) => {
          const existingMap = new Map(
            prev.map((item) => [item.orderNumber, item]),
          );

          orders.forEach((order) => {
            const alreadyRemoved = removedOrderNumbers.includes(
              order.orderNumber,
            );

            if (
              order.isSelectable &&
              !existingMap.has(order.orderNumber) &&
              !alreadyRemoved
            ) {
              existingMap.set(order.orderNumber, order);
            }
          });

          return Array.from(existingMap.values());
        });
      }
    } catch (err) {
      console.error(err);
      message.error("Failed to fetch orders");
    } finally {
      setLoadingOrders(false);
    }
  };

  const fetchOrdersStatusWise = async () => {
    // AUTO SELECT NEW CHANGES
    try {
      setLoadingOrders(true);
      const payload = {
        fromMoveDate: formFilterState.fromDate
          ? formFilterState.fromDate
          : null,
        toMoveDate: formFilterState.toDate ? formFilterState.toDate : null,
        moveType: moveType ? moveType : "",
        accordionType: selectedInvoiceStatus ? selectedInvoiceStatus : "",
        orderNumbers:
          ordersFilter?.orderIds?.length > 0 ? ordersFilter?.orderIds : [],
        sourceCities:
          ordersFilter?.sourceCities?.length > 0
            ? ordersFilter?.sourceCities
            : [],
        destinationCities:
          ordersFilter?.destinationCities?.length > 0
            ? ordersFilter?.destinationCities
            : [],
        truckTypes:
          ordersFilter?.truckTypes?.length > 0 ? ordersFilter?.truckTypes : [],
        truckRegistrationNumbers:
          ordersFilter?.truckNumbers?.length > 0
            ? ordersFilter?.truckNumbers
            : [],
        driverIds:
          ordersFilter?.driverIds?.length > 0 ? ordersFilter?.driverIds : [],
        pageNumber: currentPage,
        pageSize: pageSize,
      };

      const res = await getOrderListForInvoiceGeneration_V2(payload);
      const ordersByStatus = res?.data?.data || [];
      setInvoiceStatusWiseList(ordersByStatus);
      if (selectedInvoiceStatus === INVOICE_STATUS_TYPES.TRIPS_FOR_INVOICING) {
        const orderListFilter =
          ordersByStatus?.find(
            (section) =>
              section.accordionType ===
              INVOICE_STATUS_TYPES.TRIPS_FOR_INVOICING,
          )?.orderList || [];
        if (orderListFilter?.length > 0) {
          setOrderList(orderListFilter);
          setSelectedOrders((prev) => {
            // const existingMap = new Map(
            //   prev.map((item) => [item.orderNumber, item]),
            // );

            const existingMap = new Map([]);
            orderListFilter?.forEach((order) => {
              const alreadyRemoved = removedOrderNumbers.includes(
                order.orderNumber,
              );

              if (order.isSelectable && !alreadyRemoved) {
                existingMap.set(order.orderNumber, order);
              }
            });

            return Array.from(existingMap.values());
          });
        } else {
          setSelectedOrders([]);
          setOrderList([]);
        }
      }
    } catch (err) {
      console.error(err);
      message.error("Failed to fetch orders");
    } finally {
      setLoadingOrders(false);
    }
  };

  const fetchDraftDetail = async (draftId) => {
    try {
      const res = await getVendorInvoiceDraftDetail(draftId);

      const data = res?.data?.data;
      setExistingDraftID(draftId);
      // Prefill form
      setFormData((prev) => ({
        ...prev,
        currency: data?.currency || getCurrencyCode(user?.operatingCountry),
        invoiceId: data?.invoiceId || "",
        amount: data?.amount ? data?.amount : 0,
        vatAmount: data?.vatAmount ? data?.vatAmount : 0,
        totalAmount: data?.totalAmount ? data?.totalAmount : 0,
        uploadedInvoice:
          data?.invoiceDocs?.length > 0
            ? data?.invoiceDocs?.map((doc) => ({
                FileURL: doc.documentPath,
                FileThumbURL: doc.documentPathThumb,
                FileName: doc.fileName,
                lbDocId: doc?.lbDocId || "",
              }))
            : [],
      }));
      setDraftOrders(data?.orders || []);
      // Prefill selected orders
      setSelectedOrders(data?.orders || []);
      setFinalSelectedOrders(data?.orders || []);
    } catch (err) {
      console.error(err);
      message.error("Failed to load draft details");
    }
  };

  const fetchTripMoveTypeForInvoicing = () => {
    const payload = {
      fromMoveDate: formFilterState.fromDate,
      toMoveDate: formFilterState.toDate,
    };
    setMoveTypeLoader(true);
    getTripMoveTypeForInvoicing(payload)
      .then((res) => {
        setMoveTypeLoader(false);
        if (res.status === 200) {
          setMoveType(res.data.data);
        }
      })
      .catch((err) => {
        setMoveTypeLoader(false);
      });
  };

  const mapToLabelValue = (arr) => arr.map((z) => ({ label: z, value: z }));

  const mapToLabelValueDriver = (arr) =>
    arr?.map((z) => ({ label: z?.driverName, value: z?.driverId }));

  const fetchInvoiceOrderListFilterMasterData = () => {
    const payload = {
      fromMoveDate: formFilterState.fromDate,
      toMoveDate: formFilterState.toDate,
      moveType: moveType,
    };

    setAdditionalFilterMasterData({
      orderIds: [],
      sourceCities: [],
      destinationCities: [],
      truckTypes: [],
      truckNumbers: [],
      driverIds: [],
    });

    setIsAdditionalFilterMasterDataLoader(true);
    getInvoiceOrderListFilterMasterData(payload)
      .then((res) => {
        setIsAdditionalFilterMasterDataLoader(false);
        if (res?.data?.data) {
          let data = { ...res.data.data };
          let localAdditionalFilter = {
            orderIds: [],
            sourceCities: [],
            destinationCities: [],
            truckTypes: [],
            truckNumbers: [],
            driverIds: [],
          };

          if (data?.orderNumbers?.length > 0) {
            localAdditionalFilter.orderIds = mapToLabelValue(data.orderNumbers);
          }

          if (data?.sourceCities?.length > 0) {
            localAdditionalFilter.sourceCities = mapToLabelValue(
              data.sourceCities,
            );
          }

          if (data?.destinationCities?.length > 0) {
            localAdditionalFilter.destinationCities = mapToLabelValue(
              data.destinationCities,
            );
          }

          if (data?.truckTypes?.length > 0) {
            localAdditionalFilter.truckTypes = mapToLabelValue(data.truckTypes);
          }

          if (data?.truckRegistrationNumbers?.length > 0) {
            localAdditionalFilter.truckNumbers = mapToLabelValue(
              data.truckRegistrationNumbers,
            );
          }

          if (data?.drivers?.length > 0) {
            localAdditionalFilter.driverIds = mapToLabelValueDriver(
              data.drivers,
            );
          }
          setAdditionalFilterMasterData(localAdditionalFilter);
        }
      })
      .catch((err) => {
        setIsAdditionalFilterMasterDataLoader(false);
      });
  };

  useEffect(() => {
    if (isDraft && paramMoveType) {
      setMoveType(paramMoveType);
    } else {
      fetchTripMoveTypeForInvoicing();
    }
  }, []);

  useEffect(() => {
    if (selectedInvoiceStatus || applyFilter) {
      fetchOrdersStatusWise();
      setApplyFilter(false);
    }
  }, [selectedInvoiceStatus, applyFilter]);

  useEffect(() => {
    if (
      formFilterState.fromDate &&
      formFilterState.toDate &&
      currentPage &&
      moveType &&
      flowType === "selection"
    ) {
      //fetchOrders();
      fetchOrdersStatusWise();
    }
  }, [
    formFilterState.fromDate,
    formFilterState.toDate,
    currentPage,
    moveType,
    flowType,
  ]);

  useEffect(() => {
    if (isDraft && draftId) {
      fetchDraftDetail(draftId);
    }
  }, [draftId, isDraft]);

  useEffect(() => {
    if (!formFilterState?.fromDate || !formFilterState?.toDate) return;
    const formattedData = {
      fromDate: dayjs(formFilterState.fromDate).utc().format("YYYY-MM-DD"),
      toDate: dayjs(formFilterState.toDate).utc().format("YYYY-MM-DD"),
    };

    localStorageService.setKey("invoiceDateRange", formattedData);
  }, [formFilterState.fromDate, formFilterState.toDate]);

  const quickfilters = [
    { key: "allTime", label: t("EARNING_ALL_TIME") },
    { key: "currentMonth", label: t("EARNING_CURRENT_MONTH") },
    { key: "last7Days", label: t("EARNING_LAST_DAY") },
    { key: "last1Month", label: t("EARNING_LAST_ONE_MONTH") },
    { key: "last3Months", label: t("EARNING_LAST_MONTH") },
  ];

  const handleFilterChange = (e) => {
    setSelectedInvoiceStatus("");
    const selectedFilter = e.target.value;
    let newFromDate, newToDate;

    // Adjust fromDate and toDate based on the selected filter
    if (selectedFilter === "currentMonth") {
      newFromDate = dayjs()
        .startOf("month")
        .startOf("day")
        .utc(true)
        .toISOString();
      newToDate = dayjs().endOf("month").endOf("day").utc(true).toISOString();
    } else if (selectedFilter === "last7Days") {
      newFromDate = dayjs()
        .subtract(7, "days")
        .startOf("day")
        .utc(true)
        .toISOString();
      newToDate = dayjs().endOf("day").utc(true).toISOString();
    } else if (selectedFilter === "last3Months") {
      // newFromDate = dayjs().subtract(3, 'months').startOf('day').utc(true).toISOString();
      // newToDate = dayjs().endOf('day').utc(true).toISOString();
      newFromDate = dayjs()
        .subtract(1, "month") // get last month first
        .subtract(2, "months") // total 3 months back
        .startOf("month")
        .utc(true)
        .toISOString();

      newToDate = dayjs()
        .subtract(1, "month") // end at last month
        .endOf("month")
        .utc(true)
        .toISOString();
    } else if (selectedFilter === "last1Month") {
      newFromDate = dayjs()
        .subtract(1, "month") // get last month first
        .startOf("month")
        .utc(true)
        .toISOString();

      newToDate = dayjs()
        .subtract(1, "month") // end at last month
        .endOf("month")
        .utc(true)
        .toISOString();
    } else if (selectedFilter === "allTime") {
      newFromDate = dayjs("2024-01-01")
        .startOf("month")
        .utc(true)
        .toISOString();

      newToDate = dayjs().endOf("month").utc(true).toISOString();
    }

    setFormFilterState((prevState) => ({
      ...prevState,
      activeFilter: selectedFilter,
      fromDate: newFromDate,
      toDate: newToDate,
    }));
  };

  const handleInputChange = (value, key) => {
    setFormData((prev) => {
      const updatedData = {
        ...prev,
        [key]: value,
      };
      if (key === "amount" || key === "vatAmount") {
        const amount =
          parseFloat(key === "amount" ? value : updatedData.amount) || 0;
        const vatAmount =
          parseFloat(key === "vatAmount" ? value : updatedData.vatAmount) || 0;
        const total = amount + vatAmount;
        updatedData.totalAmount = Number.isInteger(total)
          ? total
          : Number(total.toFixed(3));
      }
      return updatedData;
    });
  };

  const handleAddInvoice = () => {
    setFinalSelectedOrders((prev) => {
      const merged = [...prev, ...selectedOrders];
      const unique = Array.from(
        new Map(merged.map((item) => [item.orderNumber, item])).values(),
      );
      if (!unique.length) {
        message.error("Please select at least one Order ID");
        return prev;
      }
      return unique;
    });
    setFlowType("manual");
  };

  const handleDateChange = (date, type) => {
    setFormFilterState((prev) => ({
      ...prev,
      activeFilter: "",
      [type === "from" ? "fromDate" : "toDate"]: date
        ? date.utc(true).toISOString()
        : null,
    }));
  };

  // Previous version to  AUTO SELECT NEW CHANGES
  // const handleSelect = (orderNumber, checked) => {
  //   const order = orderList.find((item) => item.orderNumber === orderNumber);

  //   if (!order?.isSelectable) return;

  //   setSelectedOrders((prev) => {
  //     if (checked) {
  //       // prevent duplicates
  //       if (prev.some((o) => o.orderNumber === orderNumber)) return prev;

  //       return [...prev, order];
  //     } else {
  //       return prev.filter((o) => o.orderNumber !== orderNumber);
  //     }
  //   });
  // };

  const handleSelect = (orderNumber, checked) => {
    // AUTO SELECT NEW CHANGES
    const order = orderList.find((item) => item.orderNumber === orderNumber);

    if (!order?.isSelectable) return;

    if (checked) {
      setRemovedOrderNumbers((prev) => prev.filter((id) => id !== orderNumber));
      setSelectedOrders((prev) => {
        if (prev.some((o) => o.orderNumber === orderNumber)) {
          return prev;
        }
        return [...prev, order];
      });
    } else {
      setRemovedOrderNumbers((prev) => [...prev, orderNumber]);
      setSelectedOrders((prev) =>
        prev.filter((o) => o.orderNumber !== orderNumber),
      );
      setFinalSelectedOrders((prev) =>
        prev.filter((o) => o.orderNumber !== orderNumber),
      );
    }
  };

  const handleDeleteOrder = (orderToDelete) => {
    setFinalSelectedOrders((prev) =>
      prev.filter((item) => item.orderNumber !== orderToDelete.orderNumber),
    );
  };

  const handleSkip = () => {
    setSelectedOrders([]);
    setFlowType("manual");
  };

  const handleOCRConformFileChange = (newFiles) => {
    setOcrConfirmedFiles((prevFiles) => {
      // Files that already exist (by name)
      const duplicateFiles = newFiles.filter((newFile) =>
        prevFiles.some(
          (existingFile) => existingFile.file.name === newFile.file.name,
        ),
      );

      // Files that are new
      const nonDuplicateFiles = newFiles.filter(
        (newFile) =>
          !prevFiles.some(
            (existingFile) => existingFile.file.name === newFile.file.name,
          ),
      );

      if (duplicateFiles?.length > 0) {
        message.error("File with same name already uploaded.");
        //handleDeleteUploadedDoc(newFiles[0]?.file?.name);
      }

      if (nonDuplicateFiles?.length > 0) {
        submitInvoiceOcrUpload(nonDuplicateFiles);
      }

      return [...prevFiles, ...nonDuplicateFiles];
    });
  };

  const handleOCRConfirmFileDelete = (fileNameToDelete) => {
    setOcrConfirmedFiles((prev) =>
      prev.filter((fileItem) => fileItem?.file?.name !== fileNameToDelete),
    );
    handleDeleteUploadedDoc(fileNameToDelete);
  };

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  // View Documents Handlers
  const handlePreviewClick = (fileItem) => {
    setPreviewFile(fileItem);
    setIsPreviewModalOpen(true);
  };

  const handleModalCancel = () => {
    setPreviewFile(null);
    setIsPreviewModalOpen(false);
  };

  const handleDeleteUploadedDoc = (fileName) => {
    setFormData((prev) => ({
      ...prev,
      uploadedInvoice: prev.uploadedInvoice.filter(
        (item) => item.FileName !== fileName,
      ),
    }));
    //message.success("Document removed");
  };

  // ****

  const selectedTripsCount = useMemo(() => {
  return selectedOrders?.reduce(
    (sum, order) => sum + (order?.totalTrips || 0),
    0
  );
}, [selectedOrders]);

  const totalOrders = finalSelectedOrders?.length;

  const totalTrips = finalSelectedOrders?.reduce(
    (sum, item) => sum + (item.totalTrips || 0),
    0,
  );

  const totalEarning = finalSelectedOrders?.reduce(
    (sum, item) => sum + (item.totalEarning?.amountInSupplierCurrency || 0),
    0,
  );

  const freightCost = finalSelectedOrders?.reduce(
    (sum, item) => sum + (item.baseCost?.amountInSupplierCurrency || 0),
    0,
  );

  const actualCost = finalSelectedOrders?.reduce(
    (sum, item) => sum + (item.actualCost?.amountInSupplierCurrency || 0),
    0,
  );

  const totalTripsCount  =
  invoiceStatusWiseList?.find(
    (item) =>
      item.accordionType ===
      INVOICE_STATUS_TYPES.TRIPS_FOR_INVOICING
  )?.totalTrips || 0;

  const supplierCurrency =
    finalSelectedOrders?.[0]?.totalEarning?.supplierCurrency ||
    getCurrencyCode(user?.operatingCountry);

  const buildInvoicePayload = () => {
    return {
      id: "",
      existingDraftID: existingDraftID || null,
      totalOrders,
      totalTrips,
      totalEarning,
      totalBaseCost: freightCost,
      totalActualCost: actualCost,
      currency: formData.currency || getCurrencyCode(user?.operatingCountry),
      invoiceDocs: formData?.uploadedInvoice.map((doc) => ({
        isInsertUpdate: true,
        documentPath: doc.FileURL || "",
        documentPathThumb: doc.FileThumbURL || "",
        fileName: doc.FileName || "",
        lastUpdatedBy: "",
        lbDocId: "",
      })),
      invoiceId: formData.invoiceId?.trim() ? formData.invoiceId?.trim():"",
      amount: Number(formData.amount || 0),
      vatAmount: Number(formData.vatAmount || 0),
      totalAmount: Number(formData.totalAmount || 0),
      orders: finalSelectedOrders?.map((order) => ({
        orderNumber: order.orderNumber,
        trips: (order.trips || []).map((trip) => ({
          tripId: trip.tripId,
        })),
      })),

      type: "Invoice",
      supplierId: user?.userId,
      moveType: moveType ? moveType : null,
      invoiceDate: ocrParsedData?.invoice_date
        ? ocrParsedData?.invoice_date
        : null,
    };
  };

  const handleSubmit = async () => {
    if (ocrParsedData) {
      const ocrErrorMessage = ocrParsedData?.draft_invoice_validation;
      if (ocrErrorMessage && ocrErrorMessage !== "OK") {
        message.error(ocrErrorMessage);
        return;
      }
    }

    if (formData?.uploadedInvoice?.length === 0) {
      message.error("Upload a valid document to continue");
      return;
    }

    if (!formData?.amount || formData?.amount == 0) {
      message.error("Invoice amount must be greater than zero");
      return;
    }

    if (finalSelectedOrders?.length === 0) {
      message.error("Please select at least one order");
      return;
    }

    try {
      setSubmitting(true);
      const payload = buildInvoicePayload();

      await saveVendorInvoice(payload);

      message.success("Invoice created successfully");

      // Reset after success
      setFormData({
        currency: getCurrencyCode(user?.operatingCountry),
        invoiceId: "",
        amount: "",
        vatAmount: "",
        totalAmount: "",
        uploadedInvoice: null,
      });

      setSelectedOrders([]);
      setFinalSelectedOrders([]);
      setFlowType("selection");
      navigate("/earnings/invoice-upload");
    } catch (err) {
      console.error(err);
      message.error("Failed to create invoice");
    } finally {
      setSubmitting(false);
    }
  };

  const buildDraftPayload = () => {
    return {
      id: existingDraftID || null,

      totalOrders,
      totalTrips,
      totalEarning,
      totalBaseCost: freightCost,
      totalActualCost: actualCost,

      currency: formData.currency || getCurrencyCode(user?.operatingCountry),

      invoiceDocs:
        formData.uploadedInvoice?.map((doc) => ({
          isInsertUpdate: true,
          documentPath: doc.FileURL || "",
          documentPathThumb: doc.FileThumbURL || "",
          fileName: doc.FileName || "",
          lastUpdatedBy: "",
          lbDocId: doc.lbDocId || "",
        })) || [],

      invoiceId: formData.invoiceId?.trim() ? formData.invoiceId?.trim():"",

      amount: Number(formData.amount || 0),
      vatAmount: Number(formData.vatAmount || 0),
      totalAmount: Number(formData.totalAmount || 0),

      orders: finalSelectedOrders?.map((order) => ({
        orderNumber: order.orderNumber,
        trips: (order.trips || []).map((trip) => ({
          tripId: trip.tripId,
        })),
      })),
      type: "Draft",
      moveType: moveType ? moveType : "",
      invoiceDate: ocrParsedData?.invoice_date
        ? ocrParsedData?.invoice_date
        : null,
    };
  };

  const handleSaveDraft = async () => {
    try {
      if (finalSelectedOrders?.length === 0) {
        message.error("Please select at least one order");
        return;
      }
      setSavingDraft(true);
      const payload = buildDraftPayload();

      await saveVendorInvoiceDraft(payload);

      message.success("Draft saved successfully");

      // Optional: redirect after save
      navigate("/earnings/invoice-upload");
    } catch (err) {
      console.error(err);
      message.error("Failed to save draft");
    } finally {
      setSavingDraft(false);
    }
  };

  const draftOrderNumbers = new Set(draftOrders.map((o) => o.orderNumber));

  const newSelectedCount = selectedOrders.filter(
    (o) => !draftOrderNumbers.has(o.orderNumber),
  ).length;

  const handleMoveTypeChange = (value) => {
    if (finalSelectedOrders?.length > 0 && isDraft) {
      setTempMoveType(value);
      setMoveTypeModalOpen(true);
    } else {
      setSelectedInvoiceStatus("");
      setSelectedOrders([]);
      setFinalSelectedOrders([]);
      setMoveType(value);
      setCurrentPage(1);
    }
  };

  const handleContinueModalClick = () => {
    setSelectedOrders([]);
    setFinalSelectedOrders([]);
    setMoveTypeModalOpen(false);
    setMoveType(tempMoveType);
    setCurrentPage(1);
    setSelectedInvoiceStatus("");
  };

  const handleAddOrderClick = () => {
    handleClearAdditionalFilter();
    setSelectedOrders([]);
    setSelectedInvoiceStatus("");
    setFormFilterState({
      activeFilter: "allTime",
      fromDate: dayjs("2024-01-01").startOf("month").utc(true).toISOString(),
      toDate: dayjs().endOf("month").utc(true).toISOString(),
    });
    setFlowType("selection");
  };

  const submitInvoiceOcrUpload = async (uploadedFile) => {
    setIsUploadingPopupVisible(true);
    const parsedData = await uploadToOCR(uploadedFile);
    setIsUploadingPopupVisible(false);
    setUploadState(initialUploadState);
  };

  const config = {
    onUploadProgress: function (progressEvent) {
      console.log("progressEvent.total", progressEvent.total);
      console.log("progressEvent.loaded", progressEvent.loaded);
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total,
      );

      setUploadState((prev) => {
        let status = "";
        let description = "";

        if (!prev.started) {
          status = t("OCR_MODAL_HOLD_TIGHT_MSG");
          description = t("OCR_MODAL_DO_NOT_CLOSE_MSG");
        } else if (percentCompleted < 30) {
          status = t("OCR_MODAL_HOLD_TIGHT_MSG  ");
          description = t("OCR_MODAL_DO_NOT_CLOSE_MSG");
        } else if (percentCompleted < 70) {
          status = t("OCR_MODAL_ALMOST_THERE_MSG");
          description = t("OCR_MODAL_RIGHT_PLACE_MSG");
        } else if (percentCompleted < 100) {
          status = t("OCR_MODAL_FINAL_STEP");
          description = t("OCR_MODAL_HANG_ON_MSG");
        } else {
          status = t("OCR_MODAL_FINAL_STEP");
          description = t("OCR_MODAL_HANG_ON_MSG");
        }

        return {
          progress: percentCompleted,
          status,
          description,
          started: true,
        };
      });
    },
  };

  const uploadToOCR = async (uploadedFile) => {
    if (!uploadedFile || uploadedFile?.length === 0) return;
    const form = new FormData();
    uploadedFile?.forEach((item) => {
      if (item?.file) {
        form.append("files", item.file);
      }
    });
    try {
      const response = await ocrInvoiceFileUpload(form, config);
      const parsedData = response?.data?.data;
      const newOcrLogId = response?.data?.data?.ocrLogId;
      const draftValidationMsg = response?.data?.data?.draft_invoice_validation;
      const ocrCurrency = response?.data?.data?.currency;
      if (parsedData) {
        if (
          ocrCurrency &&
          formData?.currency &&
          formData?.currency !== ocrCurrency
        ) {
          handleOCRConfirmFileDelete(uploadedFile[0]?.file?.name);
          setIsUploadingPopupVisible(false);
          setUploadState(initialUploadState);
          return message.error(
            "Invoice currency must match VAT registered country",
          );
        } else {
          setOcrParsedData(parsedData);
          fillOcrInvoiceDetails(parsedData);
          return parsedData;
        }
      } else {
        console.warn("No Data Found");
      }
    } catch (error) {
      // const messageData =
      //   error?.response?.data?.message ||
      //   "OCR upload failed due to a server error.";
      //   message.error(messageData);
      handleOCRConfirmFileDelete(uploadedFile[0]?.file?.name);
      setIsUploadingPopupVisible(false);
      setUploadState(initialUploadState);
    }
  };

  const fillOcrInvoiceDetails = (ocrData) => {
    if (!ocrData) return;
    if (ocrData) {
      const finalTotalData =
        parseFloat(ocrData?.invoice_amount) + parseFloat(ocrData?.vat_amount);
      setFormData((prev) => ({
        ...prev,
        currency: ocrData?.currency || getCurrencyCode(user?.operatingCountry),
        invoiceId: ocrData?.supplier_invoice_number || "",
        amount: ocrData?.invoice_amount
          ? parseFloat(ocrData?.invoice_amount)
          : 0,
        vatAmount: ocrData?.vat_amount ? parseFloat(ocrData?.vat_amount) : 0,
        totalAmount: finalTotalData
          ? Number.isInteger(finalTotalData)
            ? finalTotalData
            : Number(finalTotalData.toFixed(3))
          : 0,
        uploadedInvoice: [
          ...(prev.uploadedInvoice || []),
          ...(ocrData?.uploadedFiles?.map((doc) => ({
            FileURL: doc.s3Url,
            FileThumbURL: doc.s3Url,
            FileName: doc.fileName,
            lbDocId: "",
          })) || []),
        ],
      }));
    }
  };

  const handleCollapseChange = (activeKey) => {
    if (activeKey) {
      setSelectedInvoiceStatus(activeKey[0]);
    }
  };

  function hasValidValues(obj) {
    return Object.keys(obj).some((key) => {
      let value = obj[key];
      if (Array.isArray(value)) {
        return value.length > 0;
      } else if (typeof value === "object" && value !== null) {
        return hasValidValues(value);
      } else {
        return value !== "" && value !== null && value !== undefined;
      }
    });
  }

  //select source city handle
  const handleSelectSourceCity = (values) => {
    let localLiveLoadsFilter = { ...ordersFilter };
    localLiveLoadsFilter.sourceCities = values;
    setordersFilter(localLiveLoadsFilter);
  };

  const handleSelectDestinationCity = (values) => {
    let localLiveLoadsFilter = { ...ordersFilter };
    localLiveLoadsFilter.destinationCities = values;
    setordersFilter(localLiveLoadsFilter);
  };

  //select source city handle
  const handleSelectOrderId = (values) => {
    let localLiveLoadsFilter = { ...ordersFilter };
    localLiveLoadsFilter.orderIds = values;
    setordersFilter(localLiveLoadsFilter);
  };

  //select truck type handle
  const handleSelectTruckType = (value) => {
    let localLiveLoadsFilter = { ...ordersFilter };
    localLiveLoadsFilter.truckTypes = value;
    setordersFilter(localLiveLoadsFilter);
  };

  //select truck numbers handle
  const handleSelectTruckNumbers = (value) => {
    let localLiveLoadsFilter = { ...ordersFilter };
    localLiveLoadsFilter.truckNumbers = value;
    setordersFilter(localLiveLoadsFilter);
  };

  //select truck numbers handle
  const handleSelectDriverName = (value) => {
    let localLiveLoadsFilter = { ...ordersFilter };
    localLiveLoadsFilter.driverIds = value;
    setordersFilter(localLiveLoadsFilter);
  };

  const clearSourceCities = () => {
    let localLiveLoadsFilter = { ...ordersFilter };
    localLiveLoadsFilter.sourceCities = [];
    setordersFilter(localLiveLoadsFilter);
  };

  const clearDestinationCities = () => {
    let localLiveLoadsFilter = { ...ordersFilter };
    localLiveLoadsFilter.destinationCities = [];
    setordersFilter(localLiveLoadsFilter);
  };

  const clearOrderId = () => {
    let localLiveLoadsFilter = { ...ordersFilter };
    localLiveLoadsFilter.orderIds = [];
    setordersFilter(localLiveLoadsFilter);
  };

  const clearTruckTypes = () => {
    let localLiveLoadsFilter = { ...ordersFilter };
    localLiveLoadsFilter.truckTypes = [];
    setordersFilter(localLiveLoadsFilter);
  };

  const clearTruckNumbers = () => {
    let localLiveLoadsFilter = { ...ordersFilter };
    localLiveLoadsFilter.truckNumbers = [];
    setordersFilter(localLiveLoadsFilter);
  };

  const clearDriverName = () => {
    let localLiveLoadsFilter = { ...ordersFilter };
    localLiveLoadsFilter.driverIds = [];
    setordersFilter(localLiveLoadsFilter);
  };

  const handleApplyAdditionalFilter = () => {
    setFilterModal(false);
    setSelectedInvoiceStatus("");
    setApplyFilter(true);
    getAppliedFilterCount();
  };

  const getAppliedFilterCount = () => {
    const filters = [
      ordersFilter?.sourceCities,
      ordersFilter?.destinationCities,
      ordersFilter?.truckTypes,
      ordersFilter?.truckNumbers,
      ordersFilter?.orderIds,
      ordersFilter?.driverIds,
    ];
    const count = filters.filter(
      (filter) => Array.isArray(filter) && filter.length > 0,
    ).length;
    setAppliedFilterCount(count);
  };

  //clear additional filter
  const clearAdditionalFilter = (localLiveLoadsFilter) => {
    localLiveLoadsFilter.orderIds = [];
    localLiveLoadsFilter.destinationCities = [];
    localLiveLoadsFilter.truckTypes = [];
    localLiveLoadsFilter.truckNumbers = [];
    localLiveLoadsFilter.sourceCities = [];
    localLiveLoadsFilter.driverIds = [];
    return localLiveLoadsFilter;
  };

  const handleClearAdditionalFilter = () => {
    let localLiveLoadsFilter = { ...ordersFilter };
    localLiveLoadsFilter = clearAdditionalFilter(localLiveLoadsFilter);
    setordersFilter(localLiveLoadsFilter);
    setFilterModal(false);
    setApplyFilter(true);
    setAppliedFilterCount(0);
  };

  const handleSourceStateMoreFilterApply = () => {
    let localLiveLoadsFilter = { ...ordersFilter };
    setordersFilter(localLiveLoadsFilter);
    setApplyFilter(true);
  };

  const handleClearAdditionalFilterResetAddOrder = () => {
    let localLiveLoadsFilter = { ...ordersFilter };
    localLiveLoadsFilter = clearAdditionalFilter(localLiveLoadsFilter);
    setordersFilter(localLiveLoadsFilter);
    setFilterModal(false);
    setApplyFilter(false);
    setAppliedFilterCount(0);
  };

  const totalUniqueCountSelected = new Map(
    [...(finalSelectedOrders || []), ...(selectedOrders || [])].map((item) => [
      item.orderNumber,
      item,
    ]),
  ).size;

  const handleMoreFilterClick = () => {
    if (moveType && formFilterState.fromDate && formFilterState.toDate) {
      fetchInvoiceOrderListFilterMasterData();
      setFilterModal(true);
    }
  };

  return (
    <>
      <div className="invoice-upload-model-wrapper">
        <Row className="invoice-btn-row">
          <div className="invoice-upload">
            <img
              src={leftArrow}
              alt="icon"
              onClick={() => navigate(-1)}
              style={{ cursor: "pointer" }}
            />
            {t("INV_UPL_ADD_NEW_INVOICE_BACK")}
          </div>
        </Row>
        {/* OrderId Selection Flow */}
        {flowType === "selection" ? (
          <div className="order-detials-wrpper">
            <div className="filter-wrapper">
              <p className="description-text">{t("INV_UPL_POD_MSG")}</p>
              <div>
                <Row>
                  <Col span={13}>
                    <Radio.Group
                      value={formFilterState.activeFilter}
                      onChange={handleFilterChange}
                      className="filter-radio-group"
                    >
                      {quickfilters.map((filter) => (
                        <Radio.Button key={filter.key} value={filter.key}>
                          {filter.label}
                        </Radio.Button>
                      ))}
                    </Radio.Group>
                  </Col>
                  <Col>
                    <span>
                      <Button
                        type="secondary"
                        icon={
                          <img
                            src={
                              hasValidValues(ordersFilter)
                                ? filterMoreFilter
                                : FilterImg
                            }
                            alt="icon"
                          />
                        }
                        onClick={handleMoreFilterClick}
                        className={
                          hasValidValues(ordersFilter)
                            ? "orders-filter-btn more-active"
                            : "orders-filter-btn"
                        }
                      >
                        {t("LOADS_MORE_FILTERS")}&nbsp;
                        {appliedFilterCount > 0 && (
                          <span className="circle-more">
                            {appliedFilterCount}
                          </span>
                        )}
                      </Button>
                    </span>
                  </Col>
                </Row>
              </div>

              <div className="move-type-container">
                <div className="move-type-switch">
                  {moveTypesList?.map((item) => (
                    <button
                      key={item.value}
                      type="button"
                      className={`move-type-btn ${
                        moveType === item.value ? "active" : ""
                      }`}
                      onClick={() => handleMoveTypeChange(item.value)}
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
                <span>
                  <InvoiceInstructions />
                </span>
              </div>

              <Col gutter={8}>
                <Text className="filter-title">
                  {t("INV_UPL_SELECT_ORD_APPLY_MSG")}
                </Text>
                <Row gutter={16} style={{ marginTop: 12 }}>
                  <Col xs={24} md={8} gutter={16}>
                    <div className="filter-label">
                      {t("INV_UPL_MOVE_DATE_FROM")}
                    </div>
                    <DatePicker
                      className="date-picker"
                      placeholder={t("INV_UPL_MOVE_DATE_FROM_PH")}
                      format="DD/MM/YYYY"
                      style={{ width: "100%" }}
                      value={
                        formFilterState.fromDate
                          ? dayjs.utc(formFilterState.fromDate)
                          : null
                      }
                      onChange={(date) => handleDateChange(date, "from")}
                      allowClear={false}
                    />
                  </Col>

                  <Col xs={24} md={8} gutter={16}>
                    <div className="filter-label">
                      {t("INV_UPL_MOVE_DATE_TO")}
                    </div>
                    <DatePicker
                      className="date-picker"
                      placeholder={t("INV_UPL_MOVE_DATE_TO_PH")}
                      format="DD/MM/YYYY"
                      style={{ width: "100%" }}
                      value={
                        formFilterState.toDate
                          ? dayjs.utc(formFilterState.toDate)
                          : null
                      }
                      onChange={(date) => handleDateChange(date, "to")}
                      allowClear={false}
                    />
                  </Col>
                </Row>
              </Col>
            </div>
            {!invoiceStatusWiseList?.length && loadingOrders ? (
              <Spin spinning={loadingOrders} tip={t("Loading...")}></Spin>
            ) : (
              <div>
                {(finalSelectedOrders?.length > 0 ||
                  selectedOrders?.length > 0) && (
                  <Row style={{ marginBottom: "1rem" }} justify={"end"}>
                    {/* {totalUniqueCountSelected > 0 && (
                      <Col style={{ marginTop: "1rem", fontWeight: "bold" }}>
                        <span>
                          {t("INVOICE_TOTAL_SELECTED")} -{" "}
                          <b style={{ color: "var(--attention-strong)" }}>
                            {totalUniqueCountSelected}
                          </b>
                        </span>
                      </Col>
                    )} */}
                    <Col>
                      <button
                        className="button submit-btn"
                        onClick={handleAddInvoice}
                      >
                        {t("INV_UPL_SUMMARY_ADD_INVOICE_BTN")}
                      </button>
                    </Col>
                  </Row>
                )}
                <Collapse
                  accordion
                  size="large"
                  expandIconPosition="end"
                  expandIcon={({ isActive }) =>
                    isActive ? (
                      <UpOutlined style={{ fontSize: 20, fontWeight: 600 }} />
                    ) : (
                      <DownOutlined style={{ fontSize: 20, fontWeight: 600 }} />
                    )
                  }
                  onChange={handleCollapseChange}
                  activeKey={selectedInvoiceStatus}
                  items={invoiceStatusWiseList?.map((section) => ({
                    key: section.accordionType,

                    // Header
                    label: (
                      <Row
                        justify="space-between"
                        align="middle"
                        style={{ width: "100%" }}
                      >
                        <Col span={10}>
                          <span
                            style={{
                              fontSize: "18px",
                              fontWeight: "600",
                              color: `#09101D`,
                            }}
                          >
                            {section.accordionType ===
                            INVOICE_STATUS_TYPES.TRIPS_FOR_INVOICING
                              ? t("INV_TRIPS_FOR_INV_LBL")
                              : section.accordionType === "PODPending"
                                ? t("INV_POD_PENDING_LBL")
                                : t("INV_IN_REVIEW_LBL")}
                            {/* {section.accordionName} */}
                          </span>
                        </Col>
                        <Col span={10}>
                          <span style={{ color: "var(--text-subtle, #545D69B2)" }}>
                            {t("INVOICE_TRIP_LB")}
                          </span>
                          <br />
                          <span
                            style={{
                              fontSize: "20px",
                              fontWeight: "600",
                              color: `${section.accordionType === INVOICE_STATUS_TYPES.TRIPS_FOR_INVOICING ? "#19AB4F" : section.accordionType === "PODPending" ? "#E73B19" : BrandColors.primary}`,
                            }}
                          >
                            {section.currency}{" "}
                            {section.amount ? (
                              <DecimalFormatter
                                amount={section.amount}
                                country={
                                  checkIsTurkeyKazak(user?.operatingCountry)
                                    ? "TRY"
                                    : section.currency
                                }
                                flag={false}
                                isShowDecimal={true}
                              />
                            ) : (
                              "0"
                            )}
                            /
                            <span
                              style={{ fontSize: "16px", color: "var(--text, #09101D)" }}
                            >
                              {section.totalTrips}
                            </span>
                          </span>
                        </Col>
                      </Row>
                    ),
                    // Body
                    children: (
                      <>
                        {section.accordionType === "PODPending" && <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            marginBottom: "12px",
                          }}
                        >
                          <Space size={24}>
                            <Badge
                              color="#E2FAD0"
                              text="0-30 Days"
                              className="days-badge"
                            />
                            <Badge
                              color={BrandColors.tint}
                              text="30-90 Days"
                              className="days-badge"
                            />
                            <Badge
                              color="#FFBFBF"
                              text="90+ Days"
                              className="days-badge"
                            />
                          </Space>
                        </div>}
                        <Spin
                          spinning={loadingOrders}
                          tip={t("INV_UPL_SUMMARY_LOADING_ORDERS")}
                        >
                          {section.accordionType ===
                            INVOICE_STATUS_TYPES.TRIPS_FOR_INVOICING &&
                            orderList?.length > 0 && (
                              <div>
                                <Row style={{ marginBottom: "1rem" }}>
                                  <Col span={24}>
                                    <div className="selection-count-data">
                                      {/* {orderList?.length > 0 &&
                                        `${selectedOrders?.length}/${orderList?.length} ${t("INV_UPL_SELECTED_LB")}`} */}
                                      {orderList?.length > 0 &&
                                        `${selectedTripsCount}/${totalTripsCount} ${t("INV_UPL_SELECTED_LB")}`}
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            )}
                          {section?.orderList?.length > 0 ? (
                            <Row gutter={[16, 16]}>
                              {section?.orderList?.map((item) => (
                                <Col xs={24} lg={12} key={item.orderNumber}>
                                  <div
                                    className={`selectable-card ${
                                      selectedOrders.includes(item.orderNumber)
                                        ? "selected"
                                        : ""
                                    }`}
                                  >
                                    <InvoiceSummaryCard
                                      data={item}
                                      selected={selectedOrders.some(
                                        (o) =>
                                          o.orderNumber === item.orderNumber,
                                      )}
                                      onSelect={handleSelect}
                                      isReadOnly={false}
                                      accordionType={section.accordionType}
                                    />
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          ) : (
                            <Row justify={"center"}>
                              <Col>{t("INV_DATA_NOT_FOUND")}</Col>
                            </Row>
                          )}
                        </Spin>
                      </>
                    ),
                  }))}
                />
              </div>
            )}
          </div>
        ) : (
          //  ADD FLOW
          <div className="add-invoice-main-wrapper">
            <Card className="invoice-stats-card">
              {/* Top Section */}
              <Row justify="space-between" className="stats-row">
                <Col>
                  <div className="label">{t("INV_UPL_TOTAL_ORD_TRIPS_LB")}</div>
                  <div className="value">
                    {totalOrders}/{totalTrips}
                  </div>
                </Col>

                <Col>
                  <div className="label">{t("INV_UPL_TOTAL_EARNINGS_LB")}</div>
                  <div className="value">
                    {supplierCurrency}&nbsp;
                    {totalEarning ? (
                      <DecimalFormatter
                        amount={totalEarning}
                        country={
                          checkIsTurkeyKazak(user?.operatingCountry)
                            ? "TRY"
                            : supplierCurrency
                        }
                        flag={false}
                        isShowDecimal={true}
                      />
                    ) : (
                      "0"
                    )}
                  </div>
                </Col>
              </Row>

              {/* Divider */}
              <div className="divider" />

              {/* Bottom Section */}
              <Row justify="space-between" className="stats-row">
                <Col>
                  <div className="label">{t("INV_UPL_FREIGHT_COST_LB")}</div>
                  <div className="value">
                    {supplierCurrency}&nbsp;
                    {freightCost ? (
                      <DecimalFormatter
                        amount={freightCost}
                        country={
                          checkIsTurkeyKazak(user?.operatingCountry)
                            ? "TRY"
                            : supplierCurrency
                        }
                        flag={false}
                        isShowDecimal={true}
                      />
                    ) : (
                      "0"
                    )}
                  </div>
                </Col>

                <Col>
                  <div className="label">
                    {t("INV_UPL_ADDITIONAL_CHARGES_LB")}
                  </div>
                  <div className="value">
                    {supplierCurrency}&nbsp;
                    {actualCost ? (
                      <DecimalFormatter
                        amount={actualCost}
                        country={
                          checkIsTurkeyKazak(user?.operatingCountry)
                            ? "TRY"
                            : supplierCurrency
                        }
                        flag={false}
                        isShowDecimal={true}
                      />
                    ) : (
                      "0"
                    )}
                  </div>
                </Col>
              </Row>
            </Card>

            <Card className="upload-card-wrapper">
              <Row gutter={[16, 16]}>
                {/* Header */}
                <Col span={24}>
                  <div
                    className="upload-header"
                    onClick={() => setDocumentDrawerOpen(true)}
                    style={{ cursor: "pointer" }}
                  >
                    <FileTextOutlined style={{ color: "var(--attention)" }} />
                    <span>{t("INV_UPL_VIEW_DOC_LB")}</span>
                  </div>
                </Col>
                {/* Upload Section */}
                <Col span={24}>
                  <div className="invoice-upload-row">
                    <div className="invoice-document">
                      {t("INV_UPL_INV_DOC_LB")}
                    </div>
                    {/* OCR File Upload */}
                    <OCRFileUpload
                      onChange={handleOCRConformFileChange}
                      uploadedFiles={ocrConfirmedFiles}
                      onDelete={handleOCRConfirmFileDelete}
                      allowSingleFile={true}
                    />
                  </div>
                </Col>

                {/* Invoice ID */}
                <Col span={24}>
                  <div className="input-label">
                    {t("INV_UPL_INVOICE_ID_LB")}
                  </div>

                  <Input
                    value={formData.invoiceId}
                    onChange={(e) =>
                      handleInputChange(e?.target?.value, "invoiceId")
                    }
                    placeholder={t("INV_UPL_INVOICE_ID_PH")}
                    className="invoice-input-field"
                    maxLength={50}
                  />
                </Col>
                <Col span={24} className="description">
                  {t("INV_UPL_CURRENCY_MSG")}
                </Col>

                <Col span={24} style={{ maxWidth: "568px" }}>
                  <label>
                    {t("INV_UPL_INVOICE_AMT_LB")}{" "}
                    <span style={{ color: "var(--text-muted, #73777e)" }}>
                      {t("INV_UPL_INVOICE_AMT_LB_MSG_TWO")}
                    </span>
                  </label>
                  <div className="select-and-input-wrapper">
                    <Select
                      disabled={true}
                      defaultValue={formData?.currency}
                      value={formData?.currency}
                      style={{
                        width: 120,
                      }}
                    />
                    <Input
                      placeholder={t("INV_UPL_INVOICE_AMT_PH")}
                      maxLength={10}
                      value={formData.amount}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Allow only positive numbers (including decimals)
                        if (/^\d*\.?\d*$/.test(value)) {
                          handleInputChange(value, "amount");
                        }
                      }}
                    />
                  </div>
                </Col>
                <Col span={24} style={{ maxWidth: "568px" }}>
                  <label>{t("INV_UPL_INVOICE_VAT_AMT_LB")}</label>
                  <div className="select-and-input-wrapper">
                    <Select
                      disabled={true}
                      defaultValue={formData?.currency}
                      value={formData?.currency}
                      style={{
                        width: 120,
                      }}
                      // onChange={(val)=> handleCurrencyChange(val)}
                      // options={currencyOptions}
                    />
                    <Input
                      placeholder={t("INV_UPL_INVOICE_VAT_AMT_PH")}
                      //   value={enteredPrice}
                      maxLength={10}
                      value={formData.vatAmount}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Allow only positive numbers (including decimals)
                        if (/^\d*\.?\d*$/.test(value)) {
                          handleInputChange(value, "vatAmount");
                        }
                      }}
                    />
                  </div>
                </Col>
                <Col span={24} style={{ maxWidth: "568px" }}>
                  <label>{t("INV_UPL_TOATAL_INVOICE_AMT_LB")}</label>
                  <div className="select-and-input-wrapper">
                    <Select
                      disabled={true}
                      defaultValue={formData?.currency}
                      value={formData?.currency}
                      style={{
                        width: 120,
                      }}
                      // onChange={(val)=> handleCurrencyChange(val)}
                      // options={currencyOptions}
                    />
                    <Input
                      disabled={true}
                      placeholder={t("INV_UPL_TOTAL_INVOICE_AMT_LB_PH")}
                      maxLength={10}
                      value={formData.totalAmount}
                      onChange={(e) =>
                        handleInputChange(e?.target?.value, "totalAmount")
                      }
                    />
                  </div>
                </Col>
              </Row>
            </Card>
            {
              <div className="selected-orders-wrapper">
                <Row justify="space-between" align="middle">
                  {/* Left Section */}
                  <Col>
                    <Space size={8} align="center">
                      <Text className="header"> 
                        {t("INV_UPL_YOUR_SELECTED_ORD_TRIP_MSG")} 
                      </Text>
                      <Text strong className="count-lable">
                        {/* {finalSelectedOrders?.length} */}
                        {totalOrders}/{totalTrips}
                      </Text>
                    </Space>
                  </Col>

                  {/* Right Section */}
                  <Col>
                    <Button
                      type="text"
                      icon={<PlusCircleOutlined style={{ color: "var(--brand-primary-dark)" }} />}
                      className="add-orders-btn"
                      onClick={handleAddOrderClick}
                    >
                      {t("INV_UPL_ADD_ORDER_BTN")}
                    </Button>
                  </Col>
                </Row>
                {/* selected list of orders */}
                <Row gutter={[16, 16]}>
                  {finalSelectedOrders?.map((item) => (
                    <Col xs={24} lg={12} key={item.orderNumber}>
                      <div
                        className={`selectable-card ${
                          finalSelectedOrders?.includes(item.orderNumber)
                            ? "selected"
                            : ""
                        }`}
                      >
                        <InvoiceSummaryCard
                          data={item}
                          selected={finalSelectedOrders?.some(
                            (o) => o.orderNumber === item.orderNumber,
                          )}
                          isReadOnly={true}
                          // onSelect={handleSelect}
                          isDeletable={true}
                          onDelete={handleDeleteOrder}
                        />
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            }
          </div>
        )}

        {/* Footer Row */}
        {flowType !== "selection" && (
          <div className="invoice-modal-footer">
            {flowType === "selection" && (
              <>
                <div className="invoice-selection-footer">
                  <button
                    className="button submit-btn"
                    onClick={handleAddInvoice}
                  >
                    {t("INV_UPL_SUMMARY_ADD_INVOICE_BTN")}
                  </button>
                </div>
              </>
            )}
            {flowType === "manual" && !isDraft && (
              <>
                <button
                  className="button skip-btn"
                  onClick={handleSaveDraft}
                  disabled={savingDraft || submitting}
                >
                  {savingDraft
                    ? t("INV_UPL_SUMMARY_SAVE_BTN_LDR")
                    : t("INV_UPL_SUMMARY_DRAFT_INVOICE_BTN")}
                </button>
                <button
                  className="button submit-btn"
                  onClick={handleSubmit}
                  disabled={savingDraft || submitting}
                >
                  {submitting
                    ? t("INV_UPL_SUMMARY_SUBMIT_BTN_LDR")
                    : t("INV_UPL_SUMMARY_SUBMIT_BTN")}
                </button>
              </>
            )}
            {flowType === "manual" && isDraft && (
              <>
                <button
                  className="button skip-btn"
                  onClick={handleSaveDraft}
                  disabled={savingDraft || submitting}
                >
                  {savingDraft
                    ? t("INV_UPL_SUMMARY_SAVE_BTN_LDR")
                    : t("INV_UPL_SUMMARY_SAVE_BTN")}
                </button>
                <button
                  className="button submit-btn"
                  onClick={handleSubmit}
                  disabled={savingDraft || submitting}
                >
                  {submitting
                    ? t("INV_UPL_SUMMARY_SUBMIT_BTN_LDR")
                    : t("INV_UPL_SUMMARY_SUBMIT_BTN")}
                </button>
              </>
            )}
          </div>
        )}
      </div>
      {/* DRAWER */}
      <Drawer
        className="add-invoice-drawer"
        title={t("INV_UPL_VIEW_DOC_HDR_LB")}
        placement="right"
        width={420}
        open={documentDrawerOpen}
        onClose={() => setDocumentDrawerOpen(false)}
      >
        <div className="document-list-container">
          {formData?.uploadedInvoice?.length ? (
            formData.uploadedInvoice.map((docItem, index) => {
              const fileName =
                docItem?.FileName?.split("/")?.pop() || `Document ${index + 1}`;

              const fileURL = docItem?.FileURL || "";

              const isImage = fileName?.match(/\.(jpg|jpeg|png|webp)$/i);

              const isPdf = docItem?.FileName?.toLowerCase()?.endsWith(".pdf")
                ? true
                : false;
              const isDoc =
                docItem?.FileName?.toLowerCase()?.endsWith(".doc") ||
                docItem?.FileName?.toLowerCase()?.endsWith(".docx")
                  ? true
                  : false;

              return (
                <div
                  className="document-list-container-item"
                  key={index}
                  style={{ marginBottom: "16px" }}
                >
                  <Text className="doc-title">{fileName}</Text>

                  <Card
                    className="document-card"
                    style={{
                      height: "180px",
                      padding: 0,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      position: "relative",
                    }}
                    onClick={() =>
                      handlePreviewClick({
                        fileURL,
                        fileName,
                      })
                    }
                  >
                    {/* Preview */}
                    <div
                      className="file-preview-wrapper"
                      style={{ cursor: "pointer" }}
                    >
                      {isImage ? (
                        <img
                          src={fileURL}
                          alt={fileName}
                          style={{ maxWidth: "100%", maxHeight: "100%" }}
                        />
                      ) : (
                        <img
                          src={
                            isPdf
                              ? ThumbnailImagePath?.Pdf
                              : ThumbnailImagePath?.Doc
                          }
                          alt="preview"
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "contain",
                            margin: "auto",
                          }}
                        />
                      )}
                    </div>
                  </Card>

                  <Space align="center" size={8}>
                    <img
                      src={SuccessCheckIcon}
                      alt="success-check-icon"
                      width={16}
                      height={16}
                      style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                      }}
                    />
                    <Text className="size-text">
                      {t("INV_UPL_VIEW_DOC_UPLOADED_LB")}
                    </Text>
                  </Space>
                </div>
              );
            })
          ) : (
            <div>{t("INV_UPL_VIEW_DOC_NO_DATA_LB")}</div>
          )}
        </div>
      </Drawer>
      <Modal
        title="Preview"
        open={isPreviewModalOpen}
        onCancel={handleModalCancel}
        centered
        footer={null}
        width="80%"
      >
        {previewFile?.fileURL && (
          <>
            {previewFile.fileName.match(/\.(jpg|jpeg|png|webp)$/i) ? (
              <img
                src={previewFile.fileURL}
                alt={previewFile.fileName}
                style={{
                  width: "100%",
                  maxHeight: "80vh",
                  objectFit: "contain",
                }}
              />
            ) : (
              <iframe
                src={previewFile.fileURL}
                title={previewFile.fileName}
                width="100%"
                height="700px"
              />
            )}
          </>
        )}
      </Modal>

      <Modal
        open={moveTypeModalOpen}
        title={t("INV_UPL_MODAL_COMBINE_TITLE")}
        onCancel={() => setMoveTypeModalOpen(false)}
        centered
        width={580}
        height={500}
        footer={null}
      >
        <hr />
        <Row justify={"center"}>
          <Col>
            <img alt="Warning Alert" src={warningIcon} />
          </Col>
        </Row>
        <Row justify={"center"} style={{ marginTop: "0.7rem" }}>
          <Col style={{ fontSize: "16px", fontWeight: "bold" }}>
            {t("INV_UPL_MODAL_COMBINE_MSG_ONE")}
          </Col>
        </Row>

        <Row justify={"center"} style={{ marginTop: "1rem" }}>
          <Col style={{ color: "var(--text-subtle, #6D758099)" }}>
            {t("INV_UPL_MODAL_COMBINE_MSG_TWO")} <Text strong>{moveType}</Text>{" "}
            {t("INV_UPL_MODAL_COMBINE_MSG_THREE")}
            {t("INV_UPL_MODAL_COMBINE_MSG_FOUR")}
          </Col>
        </Row>

        <Row justify={"center"} style={{ marginTop: "1.5rem" }} gutter={16}>
          <Col>
            <Button size="large" onClick={() => setMoveTypeModalOpen(false)}>
              {t("INV_UPL_MODAL_COMBINE_CANCEL")}
            </Button>
          </Col>
          <Col>
            <Button
              type="primary"
              size="large"
              onClick={handleContinueModalClick}
            >
              {t("INV_UPL_MODAL_COMBINE_CONTINUE")}
            </Button>
          </Col>
        </Row>
      </Modal>

      {/* Uploading OCR Loading */}
      <Modal
        open={isUploadingPopupVisible}
        footer={null}
        closable={false}
        // onCancel={() => setIsUploadingPopupVisible(false)}
        centered
        width={352}
        style={{
          textAlign: "center",
          padding: "32px 16px",
          zIndex: "2000000 !important",
          position: "relative",
        }}
      >
        <h3
          style={{
            fontWeight: "600",
            fontSize: "18px",
            lineHeight: "1.5",
            margin: 0,
          }}
        >
          {t("OCR_MODAL_UPLOADING_PROCESSING_DOC")}
        </h3>
        <div style={{ margin: "12px 0" }}>
          <img
            // src={logo}
            src={fileSearchGif}
            alt="File Search"
            style={{ width: 112, height: 112 }}
          ></img>
        </div>

        <p
          style={{
            fontWeight: "500",
            fontSize: "14px",
            margin: 0,
            color: "var(--text-muted, #2C3A4BE5)",
          }}
        >
          {uploadState?.status}
        </p>
        <p
          style={{
            color: "var(--text, #394452)",
            fontSize: "12px",
            marginTop: "8px",
            marginBottom: 0,
            color: "var(--text-muted, #394452CC)",
          }}
        >
          {uploadState?.description}
        </p>
      </Modal>
      {/* more filter modal */}
      {filterModal && (
        <Drawer
          drawer
          placement="right"
          visible={filterModal}
          closable={false}
          width={600}
          className="orders-reverse-modal"
          title={
            <>
              <div className="orders-title-filter-modal">
                <span>{t("MORE_FILTERS")}</span>
                <Space direction="horizontal">
                  <Button
                    type="link"
                    onClick={handleClearAdditionalFilter}
                    className="orders-clear-filters"
                  >
                    {t("CLEAR_FILTERS")}
                  </Button>
                </Space>
                <Button
                  icon={<CloseOutlined />}
                  type="text"
                  onClick={() => setFilterModal(false)}
                  style={{ fontSize: "16px" }}
                />
              </div>
            </>
          }
        >
          <div className="orders-filter-holder">
            <Collapse
              className="orders-load-collapse-filter"
              expandIcon={({ isActive }) =>
                isActive ? <UpOutlined /> : <DownOutlined />
              }
              expandIconPosition={"right"}
              accordion={false}
            >
              <Panel
                key={"sourceCityFilter"}
                header={
                  <>
                    {t("SOURCE_CITY")}
                    {ordersFilter.sourceCities?.length > 0 && (
                      <span className="circle">
                        {ordersFilter.sourceCities?.length}
                      </span>
                    )}
                  </>
                }
              >
                <MultiSelectFilterSearch
                  options={additionalFilterMasterData.sourceCities}
                  onSelectionChange={handleSelectSourceCity}
                  onClear={clearSourceCities}
                  maxDisplayOptions={4}
                  initialValue={
                    ordersFilter.sourceCities?.length > 0
                      ? ordersFilter.sourceCities
                      : []
                  }
                  title={t("INVOICE_TOP_PICKS")}
                  isShowMoreFilterCount={true}
                  onMoreFilterApply={handleSourceStateMoreFilterApply}
                  loading={isAdditionalFilterMasterDataLoader}
                />
              </Panel>
            </Collapse>

            <Collapse
              className="orders-load-collapse-filter"
              expandIcon={({ isActive }) =>
                isActive ? <UpOutlined /> : <DownOutlined />
              }
              expandIconPosition={"right"}
              accordion={false}
            >
              <Panel
                key={"orderIds"}
                header={
                  <>
                    {t("ORDER_ID_LBL")}
                    {ordersFilter.orderIds?.length > 0 && (
                      <span className="circle">
                        {ordersFilter.orderIds?.length}
                      </span>
                    )}
                  </>
                }
              >
                <MultiSelectFilterSearch
                  options={additionalFilterMasterData.orderIds}
                  onSelectionChange={handleSelectOrderId}
                  onClear={clearOrderId}
                  maxDisplayOptions={4}
                  initialValue={
                    ordersFilter.orderIds?.length > 0
                      ? ordersFilter.orderIds
                      : []
                  }
                  title={t("INVOICE_TOP_PICKS")}
                  isShowMoreFilterCount={true}
                  onMoreFilterApply={handleSourceStateMoreFilterApply}
                  loading={isAdditionalFilterMasterDataLoader}
                />
              </Panel>
            </Collapse>

            <Collapse
              className="orders-load-collapse-filter"
              expandIcon={({ isActive }) =>
                isActive ? <UpOutlined /> : <DownOutlined />
              }
              expandIconPosition={"right"}
              accordion={false}
            >
              <Panel
                key={"destinationCityFilter"}
                header={
                  <>
                    {t("DESTINATION_CITY")}
                    {ordersFilter.destinationCities?.length > 0 && (
                      <span className="circle">
                        {ordersFilter.destinationCities?.length}
                      </span>
                    )}
                  </>
                }
              >
                <MultiSelectFilterSearch
                  options={additionalFilterMasterData.destinationCities}
                  onSelectionChange={handleSelectDestinationCity}
                  onClear={clearDestinationCities}
                  maxDisplayOptions={4}
                  initialValue={
                    ordersFilter.destinationCities?.length > 0
                      ? ordersFilter.destinationCities
                      : []
                  }
                  title={t("INVOICE_TOP_PICKS")}
                  isShowMoreFilterCount={true}
                  onMoreFilterApply={handleSourceStateMoreFilterApply}
                  loading={isAdditionalFilterMasterDataLoader}
                />
              </Panel>
            </Collapse>

            <Collapse
              className="orders-load-collapse-filter"
              expandIcon={({ isActive }) =>
                isActive ? <UpOutlined /> : <DownOutlined />
              }
              expandIconPosition={"right"}
              accordion={false}
            >
              <Panel
                key={"truckTypeFilter"}
                header={
                  <>
                    {t("TRUCK_TYPE")}
                    {ordersFilter.truckTypes?.length > 0 && (
                      <span className="circle">
                        {ordersFilter.truckTypes?.length}
                      </span>
                    )}
                  </>
                }
              >
                <MultiSelectFilterSearch
                  options={additionalFilterMasterData.truckTypes}
                  onSelectionChange={handleSelectTruckType}
                  onClear={clearTruckTypes}
                  maxDisplayOptions={4}
                  initialValue={
                    ordersFilter.truckTypes?.length > 0
                      ? ordersFilter.truckTypes
                      : []
                  }
                  title={t("INVOICE_TOP_PICKS")}
                  isShowMoreFilterCount={true}
                  onMoreFilterApply={handleSourceStateMoreFilterApply}
                  loading={isAdditionalFilterMasterDataLoader}
                />
              </Panel>
            </Collapse>

            <Collapse
              className="orders-load-collapse-filter"
              expandIcon={({ isActive }) =>
                isActive ? <UpOutlined /> : <DownOutlined />
              }
              expandIconPosition={"right"}
              accordion={false}
            >
              <Panel
                key={"truckNumberFilter"}
                header={
                  <>
                    {t("ORDER_TRUCK_NUMBER")}
                    {ordersFilter.truckNumbers?.length > 0 && (
                      <span className="circle">
                        {ordersFilter.truckNumbers?.length}
                      </span>
                    )}
                  </>
                }
              >
                <MultiSelectFilterSearch
                  options={additionalFilterMasterData.truckNumbers}
                  onSelectionChange={handleSelectTruckNumbers}
                  onClear={clearTruckNumbers}
                  maxDisplayOptions={4}
                  initialValue={
                    ordersFilter.truckNumbers?.length > 0
                      ? ordersFilter.truckNumbers
                      : []
                  }
                  title={t("INVOICE_TOP_PICKS")}
                  isShowMoreFilterCount={true}
                  onMoreFilterApply={handleSourceStateMoreFilterApply}
                  loading={isAdditionalFilterMasterDataLoader}
                />
              </Panel>
            </Collapse>
            <Collapse
              className="orders-load-collapse-filter"
              expandIcon={({ isActive }) =>
                isActive ? <UpOutlined /> : <DownOutlined />
              }
              expandIconPosition={"right"}
              accordion={false}
            >
              <Panel
                key={"driverFilter"}
                header={
                  <>
                    {t("ORDER_DRIVER_NAME")}
                    {ordersFilter.driverIds?.length > 0 && (
                      <span className="circle">
                        {ordersFilter.driverIds?.length}
                      </span>
                    )}
                  </>
                }
              >
                <MultiSelectFilterSearch
                  options={additionalFilterMasterData.driverIds}
                  onSelectionChange={handleSelectDriverName}
                  onClear={clearDriverName}
                  maxDisplayOptions={4}
                  initialValue={
                    ordersFilter.driverIds?.length > 0
                      ? ordersFilter.driverIds
                      : []
                  }
                  title={t("INVOICE_TOP_PICKS")}
                  isShowMoreFilterCount={true}
                  onMoreFilterApply={handleSourceStateMoreFilterApply}
                  loading={isAdditionalFilterMasterDataLoader}
                />
              </Panel>
            </Collapse>

            <Space
              className="orders-space-horizontal-space"
              direction="horizontal"
              size="middle"
            >
              <Button
                type="secondary"
                className="orders-cancel-btn"
                onClick={() => {
                  setFilterModal(false);
                }}
              >
                {t("COMMON_CANCEL_BTN")}
              </Button>
              <Button
                type="secondary"
                disabled={!hasValidValues(ordersFilter)}
                className={
                  !hasValidValues(ordersFilter)
                    ? "orders-submit-btn-disabled"
                    : "orders-submit-btn"
                }
                onClick={handleApplyAdditionalFilter}
              >
                {t("COMMON_APPLY_BTN")}
              </Button>
            </Space>
          </div>
        </Drawer>
      )}
    </>
  );
};

export default InvoiceUploadModel;
